import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import { ERetailProductSortField, IRetailProduct, PRetailProductFilter } from "src/core/retailProduct/entities";
import { ActionType, createAction, getType } from "typesafe-actions";
import { EAuthRoles } from "src/core/auth/entities";

/*
 * state
 */
export interface IRetailProductState {
  retailProducts: IRetailProduct[];
  loading: boolean;
  error: unknown;
  meta: IMeta;
}

const initialState: IRetailProductState = {
  retailProducts: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "retail-product/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "retail-product/FETCH_SUCCEEDED";
const FETCH_FAILED = "retail-product/FETCH_FAILED";
const POLLING_START_REQUESTED = "retail-product/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "retail-product/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IRetailProduct[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<unknown>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    role: EAuthRoles;
    filter: PRetailProductFilter;
    pagination: IPagination;
    sorts: ISort<ERetailProductSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IRetailProductState, TActions> = (state = initialState, action) => {
  return produce<IRetailProductState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.retailProducts = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
